module.exports = __webpack_public_path__ + "img/minus.3702abf7.svg";